import Popup from "../../../components/Popup/Popup"
import useStrings from "../../../localization/useStrings"
import styles from "./LifetimeComingSoonPopup.module.scss"

interface Props {
  visible: boolean
  onClose: () => void
}

const LifetimeComingSoonPopup = ({ visible, onClose }: Props) => {
  const strings = useStrings()

  return (
    <Popup
      title={strings.bubbleExpiration.lifetimeTitle}
      ctaTitle={strings.gotIt}
      visible={visible}
      headerImageClass={styles.headerImage}
      onClose={onClose}
    >
      <div className={styles.content}>
        <label className={styles.subtitle}>
          {strings.bubbleExpiration.lifetimeDescription}
        </label>
      </div>
    </Popup>
  )
}

export default LifetimeComingSoonPopup
